import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import Axios from "axios";
import { buildResolveUrl } from "../utils/util_functions";

/**
 * Profile Context - Provides profile data to the entire application
 * Ensures only one API call is made and shared across all components
 */
const ProfileContext = createContext();

/**
 * ProfileProvider component - Should wrap the application root
 * Provides profile data through context, with conditional loading
 */
export const ProfileProvider = ({ children}) => {
  const [profile, setProfile] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
   useEffect(() => {
    setIsLoading(true);
    const profile_payload = process.env.USER_STATUS;
    Axios.get(buildResolveUrl(profile_payload))
      .then((response) => {
        if (response.data && response.data.oxygen_id) {
          document.body.classList.add("is-user");
        } else {
          document.body.classList.remove("is-user");
        }  
        setIsDarkTheme(
          response.data &&
          response.data.subscription_status === "forge-internal"
        );

        // handle success
         setProfile(response.data);
         setIsLoaded(true);
         setError(null);
      })
      .catch((error) => {
        document.body.classList.remove("is-user");
        setProfile(null);
        setIsLoaded(true);
        setError(error);
        console.error('Profile loading error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const contextValue = {
    profile,
    isLoaded,
    isDarkTheme,
    error,
    isLoading
  };

  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
};

export default useProfile;
